import { getCoupons4Confirm, getMixPromInfo } from '@/service/product'
import {
  isEmptyObject,
  isNonEmptyArray,
  isNullOrEmpty,
  Number2Boolean,
  getRandom
} from '@/utils'
import { E_PROMOTION_TYPE } from '@/config'
import { isFlashSalePage } from '@/router/home/new/product.bus'
import { COUPON_CATEGORY_TYPE } from '@/business/coupon'

export default {
  namespaced: true,
  state: {
    promotionInfo: {},
    skuList: [],
    couponList: [],
    confirmSelCoupon: null,
    /** @typedef  {{allLimitNum,allLimitNum,promotionPrice,ruleId,skuId,spuId,type:7}} discount */
    confirmSelDiscount: null,
    discountInfo: null
  },
  mutations: {
    destroyConfirmPromotions(state) {
      state.confirmSelCoupon = null
      state.confirmSelDiscount = null
      state.discountInfo = null
      state.couponList = []
    },
    /**
     *
     * @param {coupon:{}} coupon
     */
    setSelectedCoupon(state, coupon) {
      // console.log('-------', coupon)
      state.confirmSelCoupon = coupon
      let arr = !coupon
        ? state.couponList
        : state.couponList.filter(x => x.muuid !== coupon.muuid)

      // 清空弹窗券列表选中状态
      arr.forEach(x => {
        x.checked = false
      })
    },
    setSelectedDiscount(state, discount) {
      // console.log('----setSelectedDiscount----', discount)
      state.confirmSelDiscount = discount
    },
    setPromotionInfo(state, info) {
      state.promotionInfo = info
    },
    setSKUList(state, list) {
      state.skuList = list
    },
    setCouponList(state, data) {
      const list = [...data.usableList, ...data.disableList]
      list.forEach(x => {
        // 设置唯一标识符， couponCode会出现重复的情况；couponPassword有可能为空
        x.muuid = getRandom()
        x.checked = false
        // 接口返回 0 disabled
        x.disabled = !Number2Boolean(x.disabled)
      })
      const { mixPromList } = state.promotionInfo
      // 默认第0个为最优组合，如存在券，默认选择该券
      if (isNonEmptyArray(mixPromList)) {
        let { couponDto } = mixPromList[0]

        if (!isEmptyObject(couponDto) && !isNullOrEmpty(couponDto)) {
          const { couponCode } = couponDto
          const y = list.find(x => x.couponCode === couponCode && !x.disabled)
          if (!isNullOrEmpty(y)) {
            y.checked = true
            state.confirmSelCoupon = y
          }
        }
      }

      // 存在已选择券，券列表接口重新请求的情况，此时就要匹配已选择的券
      if (state.confirmSelCoupon) {
        const s = list.find(
          x =>
            !x.disabled &&
            x.couponCode === state.confirmSelCoupon.couponCode &&
            x.couponPassword === state.confirmSelCoupon.couponPassword
        )
        if (s) {
          s.checked = true
          state.confirmSelCoupon = s
          list
            .filter(x => x.muuid !== s.muuid)
            .forEach(x => {
              x.checked = false
            })
        } else {
          state.confirmSelCoupon = null
        }
      }
      state.couponList = list
    },
    setDiscountInfo(state, data) {
      state.discountInfo = data
    }
  },
  actions: {
    /**
     *
     * @param {{skuId,spuId,businessId,level4CategoryId}} params
     * @param {Vue} vueInstance
     */
    async dispatchPromotionInfo({ commit, dispatch }, { params, vueInstance }) {
      let data = await getMixPromInfo(params)
      // 降级的处理
      if (isEmptyObject(data)) {
        data = {
          mixPromList: [],
          promList: []
        }
      }
      commit('setPromotionInfo', data)

      const { $route } = vueInstance
      // TODO 月嫂订单、待客下单 等需求暂未介入
      if ($route.name !== 'product-confirm') return

      dispatch('dispatchDiscount', vueInstance)
    },
    async dispatchDiscount({ commit, dispatch, state }, vueInstance) {
      try {
        /**
         * 订单确认页
         * 存在立减活动，新增对象
         * 订单确认页，秒杀+平台优惠券
         * 如果同时有立减促销，依然按照秒杀价和券做最优处理，不展示立减模块，也不考虑立减
         */
        // const Root = (await import('@/main')).default
        const { $route } = vueInstance
        const {
          params: { spuId },
          query: { skuId }
        } = $route

        const discountInfo = state.promotionInfo.promList
          .filter(x => +x.type === E_PROMOTION_TYPE.DISCOUNT)
          .find(x => +x.spuId === +spuId && +x.skuId === +skuId)

        // 如果最优组合内存在立减，则应该选中立减
        const { mixPromList } = state.promotionInfo
        let checked = false
        const promTypes = []

        // 默认第0个为最优组合，如存在立减，则默认选中
        if (isNonEmptyArray(mixPromList)) {
          const { promList = [], couponDto } = mixPromList[0]
          if (promList.length > 0 && discountInfo) {
            const m = promList[0]
            if (
              +m.type === E_PROMOTION_TYPE.DISCOUNT &&
              m.ruleId === discountInfo.ruleId &&
              +m.spuId === +discountInfo.spuId &&
              +m.skuId === +discountInfo.skuId
            ) {
              checked = true
            } else {
              checked = false
            }
          }
        }
        // 秒杀和立减互斥
        if (discountInfo && !isFlashSalePage($route)) {
          commit('setDiscountInfo', discountInfo)

          if (checked) {
            commit('setSelectedDiscount', discountInfo)
            promTypes.push(E_PROMOTION_TYPE.DISCOUNT)
          }
        }

        dispatch('dispatchCoupons4Confirm', { vueInstance, promTypes })
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    /**
     *
     */
    async dispatchCoupons4Confirm(
      { commit, state },
      { vueInstance, promTypes }
    ) {
      // console.log('dispatchCoupons4Confirm', promTypes)
      try {
        /**
         * 1. 判定订单确认页是否存在立减，
         * 2. 存在立减的情况下，最优组合是否是商家券，且已勾选商家券,要清除
         * 3. 不勾选商家券，没必要再重新调接口
         * 4. 平台券和立减不互斥
         */
        let goStatus = true
        if (state.couponList.length === 0) {
          goStatus = true
        } else if (promTypes.includes(E_PROMOTION_TYPE.DISCOUNT)) {
          if (
            state.confirmSelCoupon &&
            +state.confirmSelCoupon.couponCategory ===
              COUPON_CATEGORY_TYPE.BUSINESS
          ) {
            vueInstance.$$toast('促销立减活动和商家券不能同时使用')
            commit('setSelectedCoupon', null)
            goStatus = true
          } else if (
            state.couponList.find(
              x =>
                !x.disabled &&
                +x.couponCategory === COUPON_CATEGORY_TYPE.BUSINESS
            )
          ) {
            goStatus = true
          } else {
            goStatus = false
          }
        }
        if (!goStatus) return
        const {
          skuId,
          spuId,
          hasUserMatch,
          businessId: shopId,
          level4CategoryId: sortType,
          tripCalendar,
          buyNum = 1,
          confirmProduct: {
            priceInfo: { price },
            skuInfo: { skuSecType, skuTag }
          },
          $route: {
            query: { ruleId, ruleType }
          }
        } = vueInstance
        //产康福袋满足条件不展示
        if (hasUserMatch) return

        // 团购无优惠券
        if (ruleType === E_PROMOTION_TYPE.GROUP_BUY) return
        if (ruleType && +ruleType === E_PROMOTION_TYPE.FLASH_SALE) {
          promTypes.push(+ruleType)
        }
        const params = {
          skuId,
          spuId,
          shopId,
          sortType,
          price,
          promTypes
        }

        if (skuTag == 8 && skuSecType === 601) {
          //门票601取价格日历价格
          params.price = tripCalendar ? tripCalendar.price : 0
        }

        //数量
        params.price = buyNum * params.price

        // 如果有立减活动，要重新计算券满足使用条件的价格
        if (!isNullOrEmpty(state.confirmSelDiscount)) {
          params.price -= state.confirmSelDiscount.promotionPrice
          if (params.price < 0) {
            params.price = 0
          }
        }
        const { mixPromList } = state.promotionInfo
        if (isNonEmptyArray(mixPromList)) {
          const { promList = [], couponDto } = mixPromList[0]
          if (!isNullOrEmpty(couponDto) && !isEmptyObject(couponDto)) {
            // 存在最优组合是商家券的情况，需要新增促销类型参数 promTypes
            params.promTypes.push(20)
          }
        }
        // query-string 版本太低，不支持{arrayFormat: 'comma'} 手动转化
        params.promTypes = params.promTypes.join(',')
        const data = await getCoupons4Confirm(params)
        // 如果存在未清空的已选择券，匹配返回的数据
        commit('setCouponList', data)
        return data
      } catch (error) {
        console.error(error)
        throw error
      }
    }
  }
}
